
<template>


    <div class="outer-wrapper">

        <div v-if=" wallet.length == 0 " class="nothing-loaded-wrapper">

            No Cards!
        </div>
        <div v-else>

            <h3 style="margin-left: 10px">Card on File</h3>
            <div class="outer-card" v-if=" cof != null " v-for=" ( card, locKey ) in cof " :key=" locKey ">

                <div class="inner-card" >

                    <div class="image-wrapper">

                        <img :src=" cardNetwork(card.network) "/>
                    </div>
                    <div class="description-wrapper">

                        <p class="merchant-name">{{ card.name }}</p>
                        <p class="balance">last 4: {{ card.last4 }}</p>
                    </div>
                </div>
            </div>
            <div v-else>

                No Card on File for this Location!
            </div>


            <div style="width: 95%;border-bottom:1px solid #444;height:10px;margin:0 auto;"></div>


            <h3 style="margin-left: 10px">Bonus Cards</h3>
            <div class="outer-card" v-for=" ( card, cardKey ) in wallet " :key=" `B-${cardKey}` ">

                <div class="inner-card" @click=" chooseCard( card ) ">

                    <div class="image-wrapper">

                        <img :src=" card.GiftcardImage.name != null ? imageUrl + card.GiftcardImage.path + card.GiftcardImage.name : '/img/gift.png' "/>
                    </div>
                    <div class="description-wrapper">

                        <p class="merchant-name">{{ card.Merchant.name }}</p>
                        <p class="balance">${{ card.PrepaidAccount.balance }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        name: 'card-manager',
        computed: {

            ...mapGetters({

                wallet      : 'cards/wallet',
                imageUrl    : 'imageUrl',
                cof         : 'cards/cof'
            })
        },
        methods: {

            chooseCard( card ){

                this.$store.dispatch( 'cards/currentViewCard', card );
            },
            cardNetwork(network){

                switch( network ){

                    case 'VISA':

                        return "/img/visa.png";
                        break;
                    case 'MSTR':

                        return "/img/mscard.png";
                        break;
                    case 'AMEX':

                        return "/img/amcard.png";
                        break;
                    case 'DISC':

                        return "/img/discoverCard.png";
                        break;
                    default:
                    case 'DNRS':
                    case 'UKWN':

                        return "https://via.placeholder.com/200x150";
                        break;
                }

            }
        },
        created(){

            this.$store.dispatch('cards/cleanCardsWithoutCurrent');
            this.$store.commit('cards/clearCofLocally');
            //this.$store.dispatch( 'cards/getCards' );
            this.$store.dispatch( 'cards/getPaymentOptions' );
        }
    }
</script>

<style scoped>

    .outer-wrapper {

        margin: 0 auto;
        padding-top: 0 !important;
        max-width: 450px;
    }
    .outer-card {

        display: flex;
        align-items: center;

        height: 140px;
        padding: 5px;
        margin-bottom: 10px;
        background-color: white;
        font-family: Arial, Helvetica, sans-serif;
        box-shadow: 0px 3px 8px 0px rgba( 0, 0, 0, 0.5 );
    }
    .inner-card {

        display: flex;
        align-items: center;
        justify-content: space-between;

        cursor: pointer;
        position: relative;
        height: 100%;
        width: 100%;
        padding: 0px 10px;
    }

    .image-wrapper {

        position: relative;
        max-width: 125px;
        max-height: 62.5px;
    }
    .image-wrapper > img {

        width: 100%;
        max-height: 75px;
    }

    .description-wrapper {

        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: right;

        height: 100%;
    }

    .merchant-name {

        font-weight: bold;
        font-size: 14px;
    }

    .balance {

        font-weight: bold;
        padding: 10px 0px;
        font-size: 24px;
    }
</style>
